import { __rest } from "tslib";
import React from 'react';
import { BtwText } from './BtwText';
function Strong(props) {
    const { children, weight = 'semibold', variant = 'primary' } = props, rest = __rest(props, ["children", "weight", "variant"]);
    return (React.createElement(BtwText, Object.assign({ asChild: true, variant: variant, weight: weight }, rest),
        React.createElement("strong", null, children)));
}
export { Strong };
